import pagesConfig from '../pages/config';

export default {
    type: 'research',
    relations: pagesConfig.relations,
    composes: [
        'citations'
    ],
    components: {
        adminRecord: {
            name: 'AdministerResearchRecord',
            loader: () => import('./AdministerResearchRecord')
        },
        webRecord: {
            name: 'DisplayResearchRecord',
            loader: () => import('./DisplayResearchRecord')
        }
    },
}
